<script lang="ts" setup>
// What the service was authored to do, from the version the run pinned: one label and value per set field.
import type { ConfigField } from "../utils/serviceConfig";
import TransactionField from "./TransactionField.vue";
import CodeBodyViewer from "./CodeBodyViewer.vue";
import SlotText from "./bbel/SlotText.vue";

defineProps<{ fields: ConfigField[] }>();
</script>

<template>
  <dl v-if="fields.length" class="row mb-0 small">
    <TransactionField v-for="field in fields" :key="field.label" :label="field.label">
      <SlotText v-if="field.format === 'slots'" :text="field.value" />
      <SlotText v-else-if="field.format === 'expression'" :text="field.value" bare />
      <CodeBodyViewer v-else-if="field.format === 'code'" :body="field.value" slots />
      <CodeBodyViewer v-else-if="field.format === 'javascript'" :body="field.value" language="javascript" />
      <span v-else class="transaction-config-text">{{ field.value }}</span>
    </TransactionField>
  </dl>
</template>

<style scoped>
/* Rules and other multi-line text keep one entry per line. */
.transaction-config-text { white-space: pre-wrap; }
</style>
